/**
 * Bildmarke von Werkstatt-Connect — der Blitz aus dem Layout-Entwurf.
 */
export default function BrandMark({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="var(--wc-accent)"
      strokeWidth="1.6"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M13.5 3 4 14h6l-1 7 9.5-11h-6l1-7z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
